import React from 'react'

// Node Modules
import { DomElement } from 'html-react-parser'

export default ({ attribs }:DomElement, params:any, options:any) => {
  
  const empty = <></>

  if (!attribs) {
    // Not attributes
    return empty
  }

  const name = attribs['data-xis-css-ref']

  if (document.getElementById(name)) {
    return
  }

  if (!name) {
    return empty
  }

  let url = `./documentation-styles/${name}.css`
  let link = document.createElement("link")
  link.type = "text/css"
  link.rel = "stylesheet"
  link.href = url
  link.id = name
  link.setAttribute('name', 'data-xis-css-link')
  document.getElementsByTagName('head')[0].appendChild(link);
}
